import { Request } from "./Requests20";
import { url as encodeUrl } from "../utils/UrlUtil";
import { Store } from "../utils/Store";
import { trackUiError } from "../utils/TrackingUtil";
import type { Listenable } from "../utils/Store";
import type { PriceConfiguration } from "./BaseTypes";
const emptyConfig: PriceConfiguration = {
	priceCompact: {
		primary: "unitNet",
		secondary: "unitGross",
	},
	priceBreakdown: {
		primaryPriceType: "net",
		includeMarginTaxesInPrice: false,
	},
};
export interface IPriceConfigStore extends Listenable<(...args: Array<any>) => any> {
	getConfig(): PriceConfiguration;
}
export class PriceConfigStoreImpl extends Store implements IPriceConfigStore {
	_config: PriceConfiguration;

	constructor() {
		super();
		this._config = emptyConfig;
		this.loadConfig().catch((error) => {
			console.error("loadConfig in PriceConfigStore failed with ", error);
		});
	}

	async loadConfig() {
		const country = window.country;

		try {
			this._config = await requestPriceConfig(country);
		} catch (e) {
			this._config = emptyConfig;
			trackUiError("PriceConfigStore", "Failed to get price display configuration.", e as any);
		}

		this.trigger();
	}

	getConfig(): PriceConfiguration {
		return this._config;
	}
}

async function requestPriceConfig(country: string): Promise<PriceConfiguration> {
	const query = encodeUrl`country=${country}`;
	const response = await Request.get(`/searchdiscover/price-config/config?${query}`).timeout(3000).execute();
	const text = await response.text();
	return JSON.parse(text);
}

export const PriceConfigStore = new PriceConfigStoreImpl();
